export const BREAKPOINTS = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    "2xl": 1400,
    "3xl": 1680,
}